import React from "react";
import GameObjects from "../../GameObjects";

class Garden extends React.Component {

    FinishMove = () => {
        if (this.props.FinishMove) {
            this.props.FinishMove();
        }
    }

    render() {
        return <div className={`position-${this.props.absolute === true ? "absolute" : "fixed"} w-100 h-100`} style={{
            backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/images/Garden/bg.png"})`,
            backgroundPositionX: 'right',
            backgroundPositionY: 'bottom',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            top: '0'
        }}>

            <div className="position-absolute user-select-none MoveEgale d-none d-sm-block" ><GameObjects objectCss="BlueBird" status={this.props.currentStatus} FinishMove={this.FinishMove} /></div>
            <div className="position-absolute user-select-none" style={{
                left: '1%',
                bottom: '10%'
            }}><GameObjects objectCss="BoyTakeSelfie" status={this.props.currentStatus} FinishMove={this.FinishMove} /></div>
            <div className="position-absolute user-select-none" style={{
                right: '2%',
                bottom: '10%'
            }}><GameObjects objectCss="GirlTakeSelfie" status={this.props.currentStatus} FinishMove={this.FinishMove} /></div>

        </div>
    }
}
export default Garden;